import React, {useCallback, useContext, useRef, useState} from "react";
import FilterContext from "../Context/FilterContext";
import Title from "../Elements/Title";
import NumericRange from "../Form/Range/NumericRange";
import DateRange from "../Form/Range/DateRange";
import RefinementList from "../Form/List/RefinmentList";
import Toggle from "../Form/Toggle";
import { pull } from "lodash";

const Content = props => {
    const { queryFilters, setQueryFilters, setLoading, searchAttributes } = useContext(FilterContext)

    const [activeSlider, setActiveSlider] = useState()

    const retrocessionSlider = useRef()
    const salarySlider = useRef()

    const updateFilters = useCallback(({active, attribute}) => {
        setLoading(true)
        if (!active) {
            setQueryFilters([
                ...queryFilters,
                attribute
            ])
        } else {
            setQueryFilters([
                ...pull(queryFilters, attribute)
            ])
        }
    })

    const onPremiumChange = active => {
        updateFilters({ active, attribute: 'option_highlighting_active = 0' })
    }

    const onUrgentChange = active => {
        updateFilters({ active, attribute: 'option_urgent = 0' })
    }

    return (
        <>
            <div className={'flex flex-col gap-4'}>
                <Title text={'Filtrer ma recherche'} className={'text-lg'}/>
                <div className={'space-y-4 mb-4'}>
                    <hr/>
                    <Title text={'Rétrocession'}/>
                    <div className={'mx-4'}>
                        <NumericRange
                            setActiveSlider={setActiveSlider}
                            activeSlider={activeSlider}
                            reference={retrocessionSlider}
                            attribute={'amount_retrocession'}
                            trackStyle={{ backgroundColor: '#fbfcfc' }}
                            railStyle={{ backgroundColor: '#fbfcfc' }}
                            handleStyle={{borderColor: '#3B82F6' /* blue-500 */}}
                            defaultValue={0}
                            items={[
                                { label: 'Tout' },
                                { label: '50% et -', start: 0, end: 50 },
                                { label: '70% - 75%', start: 70, end: 75 },
                                { label: '80% et +', start: 80, end: 100 },
                            ]} />
                    </div>
                </div>
                <div className={'space-y-4 mb-4'}>
                    <hr/>
                    <Title text={'Salaire'}/>
                    <div className={'mx-4'}>
                        <NumericRange
                            setActiveSlider={setActiveSlider}
                            activeSlider={activeSlider}
                            reference={salarySlider}
                            reverse
                            attribute={'amount_salary'}
                            items={[
                                { label: '+ 10k€', start: 10000 },
                                { label: '+ 8000 €', start: 8000 },
                                { label: '+ 6000 €', start: 6000 },
                                { label: '+ 4000 €', start: 4000 },
                                { label: '+ 2000 €', start: 2000 },
                                { label: 'Tout' },
                            ]}
                            handleStyle={{borderColor: '#3B82F6' /* blue-500 */}}
                            trackStyle={{backgroundColor: '#DBEAFE' /* blue-100 */}}
                        />
                    </div>
                </div>
                <hr/>
                <RefinementList attribute="structure_type.name_fr" sortBy={['count']} limit={100} title={'Type de structure'} values={searchAttributes.structures ?? []}/>
                <hr/>
                <RefinementList attribute="type" sortBy={['count']} limit={100} title={'Type d\'annonce'} values={searchAttributes.types ?? []}/>
                <hr/>
                <RefinementList attribute="areas" sortBy={['count']} limit={100} title={'Aide à l\'installation'} values={searchAttributes.areas ?? []} />
                <hr/>
                <RefinementList attribute="coordinated_exercise" sortBy={['count']} limit={100} title={'Exercice coordonné'} values={searchAttributes.coordinatedExercise ?? []} />
                <hr/>
                <RefinementList attribute="filters" sortBy={['count']} limit={100} title={'Autres critères'} values={searchAttributes.filters ?? []}/>
                <hr/>
                <RefinementList attribute="skills" sortBy={['count']} limit={100} title={'Compétences'} values={searchAttributes.skills ?? []}/>
                <hr/>
                <RefinementList attribute="mountain_or_sea" sortBy={['count']} limit={100} title={'Relief'} values={searchAttributes.relief ?? []}/>
                <hr/>
                <RefinementList attribute="town_tag" sortBy={['count']} limit={100} title={'Densité'} values={searchAttributes.density ?? []}/>
                <div className={'space-y-4'}>
                    <hr/>
                    <Title text={'Visibilité'}/>
                    <div className={'flex flex-wrap gap-4'}>
                        <Toggle onChange={onPremiumChange} enabled={true} label={'Annonces Premium'}/>
                        <Toggle onChange={onUrgentChange} enabled={true} label={'Annonces Urgentes'} />
                    </div>
                </div>
                <div className={'space-y-4'}>
                    <hr/>
                    <Title text={'Date de début'}/>
                    <DateRange attribute={'date_start_timestamp'}
                               min={0}
                               max={9999999999}
                    />
                </div>
                <div className={'space-y-4'}>
                    <hr/>
                    <Title text={'Date de fin'}/>
                    <DateRange attribute={'date_end_timestamp'}
                               min={0}
                               max={9999999999}
                    />
                </div>
            </div>
        </>
    )
}

export default Content